import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { Provider } from "react-redux";
import { userLoggedIn } from "./redux/actions/AuthAction";

import tokenExp from "./utils/tokenExp";
import { logout } from "./redux/actions/AuthAction";
import store from "./store";

if (localStorage.userData) {
  if (tokenExp()) {
    store.dispatch(logout());
  }
  const user = JSON.parse(localStorage.getItem("userData"));
  store.dispatch(userLoggedIn(user));
}

ReactDOM.render(
  <Provider store={store}>
    <App />{" "}
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
